import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, NgClass],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent {
  @Input() page: number = 1;
  @Input() totalPage: number = 1;
  @Input() pageSize: number = 10;
  @Input() pageSizeOptions: number[] = [5, 10, 20, 50];
  @Output() newPage = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  sizeDropdownOpen = false;

  toggleSizeDropdown(): void {
    this.sizeDropdownOpen = !this.sizeDropdownOpen;
  }

  selectSize(size: number): void {
    this.pageSize = size;
    this.sizeDropdownOpen = false;
    this.pageSizeChange.emit(size);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.size-dropdown-wrapper')) {
      this.sizeDropdownOpen = false;
    }
  }
  pageChang(item: number) {
    this.page = item;
    this.newPage.emit(item);
  }

  // Navegación segura: siempre permite avanzar/retroceder dentro de límites
  goPrev() {
    const nextPage = Math.max(1, (Number(this.page) || 1) - 1);
    if (nextPage !== this.page) this.pageChang(nextPage);
  }

  goNext() {
    const maxPages = Math.max(1, Number(this.totalPage) || 1);
    const nextPage = Math.min(maxPages, (Number(this.page) || 1) + 1);
    if (nextPage !== this.page) this.pageChang(nextPage);
  }

  pages(): number[] {
    const n = Math.max(1, Number(this.totalPage) || 1);
    return Array.from({ length: n }, (_, idx) => idx + 1);
  }
}
